// extracted by mini-css-extract-plugin
export var active = "tabs-module--active--e3f63";
export var indicator = "tabs-module--indicator--b4a24";
export var panel = "tabs-module--panel--3b63a";
export var tab = "tabs-module--tab--09efd";
export var tablist = "tabs-module--tablist--249ca";
export var tabs = "tabs-module--tabs--812ef";